/* eslint-disable react/require-default-props */
import React from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import { getModeByBackgroundColor } from '../../helpers/colors';
export const ColorContextProvider = ({ backgroundColor = 'transparent', theme: themeProp, children, }) => {
    const themeSC = useTheme();
    const theme = themeProp || themeSC;
    const color = theme.colors[backgroundColor] || backgroundColor;
    const mode = backgroundColor === 'transparent'
        ? theme.colorContext
        : getModeByBackgroundColor(color);
    return (React.createElement(ThemeProvider, { theme: Object.assign(Object.assign({}, theme), { colorContext: mode }) }, children));
};
export const useColorContext = () => useTheme().colorContext;
